import { Box, Button, CircularProgress, InputLabel, MenuItem, Select, Stack, TextField, Typography } from "@mui/material";
import { GlobalState } from "context/GlobalContext";
import CodeIcon from "@mui/icons-material/Code";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { isStartDateGraterThanEndDate } from "utils/customDateFunctions";

const PlanningSaleQuery = () => {
	const { setSnackBar, snackBar, setSnackBarOpen } = GlobalState();
	const [loading, setLoading] = useState(false);
	const [startDate, setStartDate] = useState("");
	const [endDate, setEndDate] = useState("");
	const [department, setDepartment] = useState("");
	const [division, setDivision] = useState("SELECT");
	const [brand, setBrand] = useState("SELECT");
	const [subCategory, setSubCategory] = useState("");

	const handleRunQueryClick = async (e) => {
		e.preventDefault();
		setLoading(true);
		if ((startDate === "" && endDate !== "") || (startDate !== "" && endDate === "")) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "please enter both startdate and end date",
				severity: "warning",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoading(false);

			return;
		}
		if (isStartDateGraterThanEndDate(startDate, endDate)) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "start date should be less than end date",
				severity: "warning",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoading(false);

			return;
		}
		try {
			await axios
				.get(
					`/api/custom_queries/planning-sale-query?start_date=${startDate}&end_date=${endDate}&department=${department}&division=${division}&brand=${brand}&subcategory=${subCategory}`
				)
				.then((res) => {
					const updatedData = res.data;
					if (res.status === 200) {
						setLoading(false);
						setSnackBarOpen(true);
						setSnackBar({
							...snackBar,
							message: "file saved successfully in data hub",
							severity: "success",
							anchorOrigin: { horizontal: "center", vertical: "top" },
						});
					} else if (res.status === 204) {
						setLoading(false);
						setSnackBarOpen(true);
						setSnackBar({
							...snackBar,
							message: res.statusText,
							severity: "error",
							anchorOrigin: { horizontal: "center", vertical: "top" },
						});
					}
				});
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "failed to run query",
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoading(false);
		}
	};

	return (
		<Stack spacing={2} component="form" onSubmit={handleRunQueryClick}>
			{/* form */}
			<Box display="flex" columnGap={2} flexWrap={"wrap"} justifyContent={""} rowGap={2}>
				<Stack spacing={1}>
					<InputLabel>Select Start Date:</InputLabel>
					<TextField
						size="small"
						type="date"
						value={startDate}
						onChange={(e) => setStartDate(e.target.value)}
						sx={{ width: "200px" }}
					/>
				</Stack>
				<Stack spacing={1}>
					<InputLabel>Select End Date:</InputLabel>
					<TextField
						size="small"
						type="date"
						value={endDate}
						onChange={(e) => setEndDate(e.target.value)}
						sx={{ width: "200px" }}
					/>
				</Stack>
				<Stack spacing={1}>
					<InputLabel>Enter Department</InputLabel>
					<TextField
						size="small"
						type="text"
						value={department}
						placeholder="Enter Department"
						onChange={(e) => setDepartment(e.target.value.toUpperCase())}
					/>
				</Stack>
				<Stack spacing={1}>
					<InputLabel>Enter Subcategory</InputLabel>
					<TextField
						size="small"
						type="text"
						value={subCategory}
						placeholder="Enter Subcategory"
						onChange={(e) => setSubCategory(e.target.value.toUpperCase())}
					/>
				</Stack>
				<Stack spacing={1}>
					<InputLabel>Division</InputLabel>
					<Select value={division} onChange={(e) => setDivision(e.target.value)} sx={{ width: "200px" }} size="small">
						<MenuItem value={"SELECT"}>SELECT</MenuItem>
						<MenuItem value={"APPARELS"}>APPARELS</MenuItem>
						<MenuItem value={"FOOT WEAR"}>FOOT WEAR</MenuItem>
						<MenuItem value={"ADDONS"}>ADDONS</MenuItem>
					</Select>
				</Stack>
				<Stack spacing={1}>
					<InputLabel>Brand</InputLabel>
					<Select value={brand} onChange={(e) => setBrand(e.target.value)} sx={{ width: "200px" }} size="small">
						<MenuItem value={"SELECT"}>SELECT</MenuItem>
						<MenuItem value={"RARE RABBIT"}>RARE RABBIT</MenuItem>
						<MenuItem value={"RAREISM"}>RAREISM</MenuItem>
					</Select>
				</Stack>
			</Box>
			<Button
				variant="contained"
				sx={{ width: "200px" }}
				type="submit"
				disabled={loading}
				startIcon={loading ? <CircularProgress color="inherit" size="20px" /> : <CodeIcon />}>
				{loading ? "Loading..." : "Run"}
			</Button>
		</Stack>
	);
};

export default PlanningSaleQuery;
